import type { DataSourceConfig } from '../types/dataSource'

const DATA_SOURCE_CONFIG_KEY = 'yujian:data-source-config'

export function loadDataSourceConfigs(fallback: DataSourceConfig[]) {
  try {
    const stored = window.localStorage.getItem(DATA_SOURCE_CONFIG_KEY)

    if (!stored) {
      return fallback
    }

    const parsed: unknown = JSON.parse(stored)

    if (!Array.isArray(parsed)) {
      return fallback
    }

    return parsed as DataSourceConfig[]
  } catch {
    return fallback
  }
}

export function saveDataSourceConfigs(configs: DataSourceConfig[]) {
  window.localStorage.setItem(DATA_SOURCE_CONFIG_KEY, JSON.stringify(configs))
}
